import { Box, Button, CircularProgress, DialogActions, FormLabel, MenuItem, Select, TextField, Typography } from '@mui/material';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../../../../../../../redux/store';
import { closeDrawer } from '../../../../../../../../../redux/reducer/drawerSlice';
import { showSnackbar } from '../../../../../../../../../redux/reducer/snackbarSlice';
import { setModuleRefresh } from '../../../../../../../../../redux/reducer/registration/RefreshSlice';
import { VerifyBeneficiaryDocService } from '../../../../../../../../../utils/services/collaboration-agreement/collaboration-agreement.service';
import { VerifiedUser } from '@mui/icons-material';

const VerifyDocDrawer: React.FC = () => {
    const dispatch = useDispatch();
    const { drawerData } = useSelector((state: RootState) => state.drawer);
    const refreshFlag = useSelector((state: RootState) => state.refreshSlice.beneficiary_details);

    const [status, setStatus] = useState<string>('approved');
    const [remarks, setRemarks] = useState<string>('');
    const [isLoading, setIsLoading] = useState(false);

    const handleSubmit = async () => {
        if (!remarks.trim()) {
            dispatch(showSnackbar({ type: 'error', message: 'Please enter remarks' }));
            return;
        }
        setIsLoading(true);
        const payload = {
            Beneficiary_uuid: drawerData?.beneficiary_uuid,
            document_uuid: drawerData?.document_uuid,
            document_type: drawerData?.document_type,
            status,
            remarks,
        };
        const { code, message } = await VerifyBeneficiaryDocService(payload);
        if (code === 200) {
            dispatch(showSnackbar({ type: 'success', message: message || 'Document verified successfully' }));
            dispatch(setModuleRefresh({ moduleName: 'beneficiary_details', refresh: !refreshFlag }));
            dispatch(closeDrawer());
        } else {
            dispatch(showSnackbar({ type: 'error', message: message || 'Something went wrong' }));
        }
        setIsLoading(false);
    };

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: 'calc(100vh - 59px)', maxHeight: 'calc(100vh - 59px)', backgroundColor: 'background.default' }}>
            <Box sx={{ flex: '1 1', overflowY: 'scroll', p: 2 }}>
                <Box sx={{ mb: 2, p: 2, bgcolor: 'grey.50', borderRadius: 2, border: '1px solid', borderColor: 'divider' }}>
                    <Typography variant="body2" color="text.secondary" fontWeight={600}>Document Type</Typography>
                    <Typography variant="body1" fontWeight={700} sx={{ textTransform: 'capitalize', mt: 0.5 }}>
                        {drawerData?.document_type?.replace(/_/g, ' ')}
                    </Typography>
                </Box>

                <Box sx={{ mb: 2 }}>
                    <FormLabel>Verification Status <span style={{ color: 'red' }}>*</span></FormLabel>
                    <Select
                        fullWidth
                        size="small"
                        value={status}
                        onChange={(e) => setStatus(e.target.value)}
                        sx={{ mt: 0.5 }}
                    >
                        <MenuItem value="approved">Approved</MenuItem>
                        <MenuItem value="rejected">Rejected</MenuItem>
                    </Select>
                </Box>

                <Box sx={{ mb: 2 }}>
                    <FormLabel>Remarks <span style={{ color: 'red' }}>*</span></FormLabel>
                    <TextField
                        fullWidth
                        size="small"
                        multiline
                        minRows={3}
                        placeholder="Enter verification remarks"
                        value={remarks}
                        onChange={(e) => setRemarks(e.target.value)}
                        sx={{ mt: 0.5 }}
                    />
                </Box>
            </Box>

            <DialogActions sx={{ py: 1, px: 2, backgroundColor: '#f5f5f5' }}>
                <Button
                    variant="contained"
                    color={status === 'approved' ? 'success' : 'error'}
                    disabled={isLoading}
                    onClick={handleSubmit}
                    endIcon={isLoading ? <CircularProgress size={18} color="inherit" /> : <VerifiedUser />}
                >
                    {isLoading ? 'Submitting...' : status === 'approved' ? 'Approve Document' : 'Reject Document'}
                </Button>
            </DialogActions>
        </Box>
    );
};

export default VerifyDocDrawer;
